import { Label, Select } from '@shared/components';

interface CollectionCountSelectProps {
    /** Inclusive lower bound of the offered counts (`CollectionCountChoice.min`). */
    min: number;
    /** Inclusive upper bound (`CollectionCountChoice.max`). */
    max: number;
    /** The currently-selected count — the effective override, or the pre-selected derived count. */
    value: number;
    onChange: (count: number) => void;
}

/** Presentational: `PaymentStep` owns the range and the selected value, so every offered value
 *  is already valid and this control carries no validation of its own. */
export function CollectionCountSelect({ min, max, value, onChange }: CollectionCountSelectProps) {
    const options = Array.from({ length: max - min + 1 }, (_, index) => {
        const count = min + index;
        return { value: String(count), label: String(count) };
    });

    return (
        <div data-testid="collection-count" className="space-y-1.5">
            <Label htmlFor="collection-count-select">Number of collections</Label>
            <Select
                id="collection-count-select"
                options={options}
                value={String(value)}
                onChange={(next) => onChange(Number(next))}
                ariaLabel="Number of collections"
            />
        </div>
    );
}
